import Vue from 'vue';
import Vuex from 'vuex';
import VueRouter from 'vue-router';
import VueFetchRoute from 'vue-fetch-route';
import VueLog from '@dreipol/vue-log';

import AppRoot from 'framework/base/root.vue';
import initVuex from 'framework/vuex';
import initRouter from 'framework/router';
import registry from './registry';
import vueLogConfig from './vue-log-config';
import Axios from 'util/service';

const CMS = window.CMS;
const isInCMS = Boolean(CMS);


/**
 * Bootstrap the vue root instance
 * @return {Promise} A promise returning when the registry has loaded all components and the app was initialized
 */
export function init() {
    // NOTE: Plugin initialisation is run before registry because new merge strategies might be applied by plugins.
    Vue.use(Vuex);
    Vue.use(VueLog, vueLogConfig);
    Vue.use(VueRouter);
    Vue.use(VueFetchRoute, {
        log: Vue.log({ context: { location: 'vue-fetch-route' } }).debug,
        fetch(url) {
            return new Promise((resolve, reject) => {
                Axios.request({ url }).then(response => resolve(response.data), error => reject(error));
            });
        },
        ignoredQueryParams: ['partials', 'edit', 'edit_off', 'language'],
        vuexModule: 'router',
    });

    return registry().then(() => {
        initVuex(AppRoot);
        initRouter(AppRoot);

        if (isInCMS) {
            CMS.$(window).on('cms-content-refresh', () => CMS.API.Helpers.reloadBrowser());
        }

        // Instantiate the root vue instance
        return new Vue({ render: h => h(AppRoot) }).$mount('#root');
    });
}
